import loansApiClient from '@app/clients/loans-api-client';
import createBaseQuery from './createBaseQuery';
const loansApiBaseQuery = createBaseQuery(loansApiClient);
export default loansApiBaseQuery;
